import { Text, View } from '@react-pdf/renderer';
import { styles } from '../style/pdfStyles';

interface PdfKeyValueTableProps {
  rows: Array<{ label: string; value: string }>;
  emptyMessage?: string;
}

export const PdfKeyValueTable = ({ rows, emptyMessage }: PdfKeyValueTableProps) => {
  if (rows.length === 0) {
    return <Text style={[styles.text, styles.mutedText]}>{emptyMessage || '—'}</Text>;
  }

  return (
    <View style={styles.table}>
      {rows.map((row, index) => (
        <View
          key={`${row.label}-${index}`}
          style={[
            styles.tableRow,
            index === rows.length - 1 ? styles.tableRowLast : null,
          ]}
        >
          <Text style={styles.tableCellLabel}>{row.label}</Text>
          <Text style={styles.tableCellValue}>{row.value}</Text>
        </View>
      ))}
    </View>
  );
};
